import { LazyAction, LazyBootModule } from 'owa-bundling-light';
export { getFoldersToShowFirst } from './util/getFoldersToShowFirst';

const lazyModule = new LazyBootModule(
    () => import(/* webpackChunkName: "OwaHierarchyBoostrap" */ './lazyIndex')
);

export const lazyBootstrapFolderHierarchyCache = new LazyAction(
    lazyModule,
    m => m.bootstrapFolderHierarchyCache
);
